import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Resolve, Router, UrlTree } from "@angular/router";
import { GroupService } from "app/core/services/admin/group/group.service";
import { UserService } from "app/core/services/admin/user/user.service";
import { MaestroGroup } from "app/shared/models";
import { forkJoin, Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class GroupFormGuard implements Resolve<MaestroGroup>, CanActivate {
    constructor(private _service: GroupService, private userService: UserService, private router: Router) {}
    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        return true;
    }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        const groupId = route.params.id;
        return forkJoin([this.userService.getAll(), this._service.findById(groupId)]).pipe(
            map(
                (data) =>
                    <any>{
                        users: data[0]["data"].map((user, i) => ({ id: user.id, name: user.firstName + " " + user.lastName })),
                        group: data[1].data,
                        groupId: groupId,
                    }
            )
        );
    }
}
